import 'css-chunksrc/client/scenes/event/participantsList/resource/styles.scss';export default {
  "resource": "_resource_xcumy_1",
  "iconBox": "_iconBox_xcumy_18",
  "icon": "_icon_xcumy_18"
};